// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 674 ? "eba100ab" : chunkId) + "." + {"376":"cd048154caca516c","674":"f45aac9c2b941dcd"}[chunkId] + ".js";
};